import { useGetTicketSalesQuery } from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'
import type { FetchTicketSaleListParams } from 'Services/SalesManagement/Features/TicketSale/types'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_TICKET_SALE_PARAMETER_KEY = 'selectedTicketSale'

const useTicketSalesWithParams = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [params, setParams] = useState<FetchTicketSaleListParams>({
    ordering: searchParams.get('ordering') ?? '-created',
    page: searchParams.get('page') ? parseInt(searchParams.get('page') as string) : 1
  })

  const { data, isFetching } = useGetTicketSalesQuery(params)

  const selectedTicketSaleQueryParam =
    searchParams.get(SELECTED_TICKET_SALE_PARAMETER_KEY) ?? undefined

  const [selectedTicketSaleId, setSelectedTicketSaleId] = useState(selectedTicketSaleQueryParam)

  const setQueryParams = () => {
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    if (selectedTicketSaleId) {
      searchParams.set(SELECTED_TICKET_SALE_PARAMETER_KEY, selectedTicketSaleId)
    }

    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [params])

  useEffect(() => {
    if (selectedTicketSaleId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_TICKET_SALE_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedTicketSaleId])

  return {
    data,
    isFetching,
    params,
    setParams,
    selectedTicketSaleId,
    setSelectedTicketSaleId
  }
}

export default useTicketSalesWithParams
